import NewQuestionTexts from './QuestionTextsModel';

function GetLanguageTexts(texts, languageCode) {    
    if (texts == null) {
        texts = [];
    }
    for (var i = 0; i < texts.length; i++) {
        if (texts[i].languageCode === languageCode) {
            return texts[i];
        }
    }    
    return NewQuestionTexts(languageCode);
}

function addMissingLanguageTexts(selectedQuestion, languageCode, updateSelectedQuestionCallback) {
    if (selectedQuestion == null || languageCode == null || updateSelectedQuestionCallback == null) {
        return
    }
    var updated = false;
    if (selectedQuestion.texts.find(t=>t.languageCode === languageCode) == null) {       
        var newLanguageTexts = NewQuestionTexts(languageCode);
        selectedQuestion.texts.push(newLanguageTexts);
        updated = true;        
    }

    if (selectedQuestion.options != null) {
        selectedQuestion.options.forEach(option => {
            if (option.texts == null) {
                option.texts = [];
            }
            if (option.texts.find(t=>t.languageCode === languageCode) == null) {
                option.texts.push(NewQuestionTexts(languageCode));
                updated = true;
            }
        });        
    }

    if (selectedQuestion.groupStatements != null) {
        selectedQuestion.groupStatements.forEach(gridQuestion => {
            if (gridQuestion.texts == null) {
                gridQuestion.texts = [];
            }
            if (gridQuestion.texts.find(t=>t.languageCode === languageCode) == null) {
                gridQuestion.texts.push(NewQuestionTexts(languageCode));
                updated = true;
            }
        });        
    }

    if (updated) {
        updateSelectedQuestionCallback(selectedQuestion);
    }
}

export { GetLanguageTexts, addMissingLanguageTexts };

